<template lang="pug">
.vheader
  .container
    a(href="/")
      img.logo(src='../assets/imgs/header-logo-m.png', alt='前沿社')
    ul
      li(:class="{active : $route.name == 'intro'}")
        a(href="/intro") 项目介绍
      li(:class="{active : $route.name == 'news'}")
        a(href="/news") 前沿动态
      li(:class="{active : $route.name == 'entry'}")
        a(href="/entry") 会员申请
      //- li(:class="{active : $route.name == 'observer'}")
        a(href='/observer') 观察员申请
      li(:class="{active : $route.name == 'en'}")
        a(href="/en") En
    img.navBtn(v-bind:src='navSrc()', v-on:click='navClick()')
</template>

<script>
export default {
  name: 'vheader',
  computed: {
    isNavClick () {return this.$store.state.isNavClick}
  },
  methods: {
    navSrc: function () {
      return this.isNavClick ? require("../assets/imgs/close.svg") : require("../assets/imgs/list.svg")
    },
    navClick: function () {this.$store.commit('navClick')}
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.navBtn
  display none
.vheader
  position fixed
  z-index 20
  width 100%
  background-color black
  top 0
  .container
    position relative
  .logo
    height 72px
    padding 10px 0
    box-sizing border-box

  ul
    position absolute
    right 0
    top 0
    bottom 0
    &::before
      content ''
      display inline-block
      height 100%
      vertical-align middle

    li
      display inline-block
      margin 0 20px
      text-align center
      line-height 2.4em
      a
        display inline
        color #ffffff
        font-size 16px
        transition all 0.5s
      &.router-link-active
      &.active
        border-bottom 2px solid #fff
        font-weight 900

    .english-down
      vertical-align middle
      height 1.1em
      margin 0 2px
@media $media
  .vheader
    transition all 1s
    -webkit-backface-visibility hidden
    .logo
      height 48px
      margin-left -5px

    .navBtn
      display block
      position absolute
      right 20px
      width 24px
      top 14px

    ul
      display none
      right 6px
      li
        margin 0 5px
        a
          font-size 14px
@media only screen and (max-width: 350px)
  .vheader
    ul
      li
        margin 0 3px
        a
          font-size 12px

</style>



// WEBPACK FOOTER //
// Vheader.vue?9692f914